// Central registry of data-testid values used across the app.
export const T = {
  // Auth / login
  loginManagerIdInput: "login-manager-id-input",
  loginSubmitButton: "login-submit-button",
  loginError: "login-error",

  // Bottom nav
  navHome: "nav-home",
  navPlayers: "nav-players",
  navAskFpl: "nav-ask-fpl",
  navMyTeam: "nav-my-team",
  navLeagues: "nav-leagues",

  // Top header
  topManagerRank: "top-manager-rank",
  topManagerPoints: "top-manager-points",
  topMenuButton: "top-menu-button",
  topProfileButton: "top-profile-button",
  topLogoutButton: "top-logout-button",

  // Home dashboard
  homeDashboard: "home-dashboard",
  homeDeadlineCountdown: "home-deadline-countdown",
  homeLiveScore: "home-live-score",
  homeLiveRank: "home-live-rank",
  homeCaptainCard: "home-captain-card",
  homeFixturesRail: "home-fixtures-rail",
  homeTrendingList: "home-trending-list",

  // Players
  playersPage: "players-page",
  playersSearch: "players-search-input",
  playersPositionFilter: "players-position-filter",
  playersTeamFilter: "players-team-filter",
  playersMaxPriceFilter: "players-max-price-filter",
  playersSortSelect: "players-sort-select",
  playersList: "players-list",
  playersRow: "players-row",

  // Player detail
  playerDetail: "player-detail",
  playerFormChart: "player-form-chart",
  playerUpcoming: "player-upcoming",

  // Fixtures / FDR
  fixturesPage: "fixtures-page",
  fdrGrid: "fdr-grid",
  fdrWeeksSelect: "fdr-weeks-select",

  // My Team
  myTeamPage: "my-team-page",
  myTeamPitch: "my-team-pitch",

  // Leagues
  leaguesPage: "leagues-page",
  leagueRow: "league-row",
  leagueStandings: "league-standings",

  // Profile
  profilePage: "profile-page",

  // Ask FPL
  askPage: "ask-fpl-page",
  askInput: "ask-fpl-input",
  askSend: "ask-fpl-send",
  askSquadToggle: "ask-fpl-squad-toggle",
  askNewChat: "ask-fpl-new-chat",
  askSessionList: "ask-fpl-session-list",
  askMessages: "ask-fpl-messages",
  askAssistantMessage: "ask-fpl-assistant-message",
  askUserMessage: "ask-fpl-user-message",
  askSuggestion: "ask-fpl-suggestion",

  // Compare
  comparePage: "compare-page",
  compareSlotA: "compare-slot-a",
  compareSlotB: "compare-slot-b",
  compareSearchA: "compare-search-a",
  compareSearchB: "compare-search-b",
  compareStatRow: "compare-stat-row",
  comparePredictedTotalA: "compare-predicted-total-a",
  comparePredictedTotalB: "compare-predicted-total-b",

  // Rank Gap
  rankGapPage: "rank-gap-page",
  rankGapRow: "rank-gap-row",
  rankGapUserRow: "rank-gap-user-row",

  // Live tracker
  livePage: "live-page",
  liveTabOverall: "live-tab-overall",
  liveTabLeague: "live-tab-league",
  liveStatus: "live-status",
  liveGwPoints: "live-gw-points",
  liveRank: "live-rank",
  liveCaptainCard: "live-captain-card",
  liveLeagueSelect: "live-league-select",
  liveLeagueTable: "live-league-table",

  // Rival diff
  leagueDiffPage: "league-diff-page",
  leagueDiffYourDiff: "league-diff-your-diff",
  leagueDiffMissing: "league-diff-missing",
  leagueDiffGrid: "league-diff-grid",

  // League dashboard
  leagueDashboardPage: "league-dashboard-page",

  // Profile edit
  profileDisplayNameInput: "profile-display-name-input",
  profileFavTeamSelect: "profile-fav-team-select",
  profileSaveButton: "profile-save-button",
};
